"use client";
import Link from "next/link";
import type { Route } from "next";
import { useTranslations } from "next-intl";
import { Button } from "@/components/ui/button";
import { useAwardRuntime } from "./award-runtime";
export function AwardOperationNotices() {
  const runtime = useAwardRuntime(),
    t = useTranslations("awards");
  if (
    !runtime.ready ||
    (runtime.available && !runtime.records.length && !runtime.terminal)
  )
    return null;
  return (
    <aside
      data-slot="award-operation-notices"
      data-debug-source="src/components/awards/award-operation-notices.tsx"
      aria-live="polite"
      className="m-4 space-y-3 rounded-lg border border-warning-border bg-warning-soft p-4 text-sm text-warning-foreground"
    >
      {!runtime.available ? (
        <>
          <p>{t("storage")}</p>
          <Button variant="outline" onClick={runtime.restore}>
            {t("retryStorage")}
          </Button>
        </>
      ) : null}
      {runtime.records.map((row) => (
        <div
          key={row.idempotencyKey}
          className="flex flex-wrap items-center gap-3"
        >
          <p className="basis-full">{t("unknown")}</p>
          <Button
            variant="outline"
            disabled={runtime.pending}
            onClick={() => void runtime.lookup(row)}
          >
            {t("lookup")}
          </Button>
          {row.awardId && row.operationType !== "award.submit" ? (
            <Button asChild variant="ghost">
              <Link
                href={
                  `/awards/${row.awardId}?proposalId=${row.proposalId}` as Route
                }
              >
                {t("openDossier")}
              </Link>
            </Button>
          ) : null}
        </div>
      ))}
      {runtime.lookupFailed ? <p role="alert">{t("lookupFailed")}</p> : null}
      {runtime.terminal ? (
        <div className="flex flex-wrap items-center gap-3">
          <p>{t(runtime.terminal === "Completed" ? "recovered" : "failed")}</p>
          <Button variant="outline" onClick={runtime.dismiss}>
            {t("dismiss")}
          </Button>
        </div>
      ) : null}
    </aside>
  );
}
